// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resumen_tournament{font-family:Montserrat;font-size:30px;font-weight:600;line-height:37px;letter-spacing:0;text-align:left;color:#f4f4f4;background-color:#2a4558;text-align:center}@media (max-width:600px){.resumen_tournament{font-size:24px}}.green-background{background-color:#99d49e}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
